import { View, Image} from "@aws-amplify/ui-react";
import styled, { useTheme } from "styled-components";
import { AH4 } from "./text";
 
const Wrap = styled(View)`
    margin: 0px 30px;
    margin-top:20px;
`

export const SignupHeader = () => {
    //const { tokens } = useTheme();

    return (
        <Wrap textAlign="center">
            <AH4>Creating an account allows us to tailor your nutrition package to you.</AH4>
        </Wrap>
    );
}